import { Component, OnInit, ViewChild } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Calendar } from 'primeng/calendar';

@UntilDestroy()
@Component({
  selector: 'app-date-range-selector',
  templateUrl: './date-range-selector.component.html',
  styleUrls: ['./date-range-selector.component.scss']
})
export class DateRangeSelectorComponent implements OnInit {
  @ViewChild('calendar') calendar?: Calendar;

  rangeDates: Date[] | undefined;
  isError = false;
  
  constructor(
    private ref: DynamicDialogRef,
    private dialogConfig: DynamicDialogConfig,
  ) { }

  ngOnInit(): void {
    const data = this.dialogConfig.data;
    this.rangeDates = data.rangeDates;

  }

  public close(payload?: any) {
    this.ref.close(payload);
  }

  cancelClicked() {
    this.close();
  }

  saveClicked() {
    if (this.rangeDates?.length !== 2) {
      this.isError = true;
    } else {
      const utcRange = this.convertToUTC(this.rangeDates)
      const startDate = utcRange[0];
      const endDate = utcRange[1];
      this.close({startDate, endDate});
    }
  }

  convertToUTC(rangeDates: Date[] | undefined) {
    if (!rangeDates) {
      return [];
    }

    return rangeDates.map(date => {
      return new Date(Date.UTC(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        date.getUTCHours(),
        date.getUTCMinutes(),
        date.getUTCSeconds(),
        date.getUTCMilliseconds()
      ));
    });
  }

  onDateRangeSelect() {
    if (this.rangeDates && this.rangeDates.length === 2) {
      this.closeCalendar();
      // Add your function call here
    }
    this.isError = false;
  }
  
  closeCalendar() {
    // this.calendar?.overlayVisible = false;
  }

}
